import styled from 'styled-components';

const InputContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  margin-right: 16px;
  height: 25.5px;
`;

const Input = styled.input`
  &:checked + span {
    background-color: #000;
  }
  &:disabled + span {
    background-color: #eaedf3;
    cursor: not-allowed;
  }
  &:disabled:checked + span {
    background-color: #eaedf3;
    cursor: not-allowed;
  }
  &:focus + span {
    box-shadow: 0 0 1px #2196f3;
  }
  &:checked + span:before {
    -webkit-transform: translateX(${({ translate }) => translate}px);
    -ms-transform: translateX(${({ translate }) => translate}px);
    transform: translateX(${({ translate }) => translate}px);
  }
  visibility: hidden;
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #dfdfdf;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  border-radius: 25px;
  &:before {
    position: relative;
    border-radius: 50%;
    content: '';
    height: 20px;
    width: 20px;
    left: ${(props) => (props.toggled ? '2.5px' : '17.4px')};
    background-color: ${(disabled) =>
      disabled.checked && disabled.disabled ? '#ccd0e3' : '#fff'};
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const StyledToggleSwitch = {
  Slider,
  Input,
  InputContainer,
  Row,
};

export default StyledToggleSwitch;
